import { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Helmet } from 'core/libs/helmet';
import { withRouter } from 'core/libs/router';

import { hasPreviewToken } from 'core/utils/url-helper';

import codes from './codes';

function AmpCounter({ counterIds, location: { search } }) {
  if (!counterIds || hasPreviewToken(search)) {
    return null;
  }

  return (
    <Fragment>
      <Helmet>
        <script
          async='async'
          custom-element='amp-analytics'
          src='https://cdn.ampproject.org/v0/amp-analytics-0.1.js'
        />
      </Helmet>
      {Object.keys(counterIds || {}).map(counterName => {
        const counterCode = codes[counterName].amp;
        if (!counterCode) return null;

        const counterIdsArr =  [].concat(counterIds[counterName]).filter(Boolean);

        return counterIdsArr.map(counterCode);
      })}
    </Fragment>
  );
}

AmpCounter.propTypes = {
  counterIds: PropTypes.object,
  /** @ignore */
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(AmpCounter);
